import {
  NeedDto,
  NeedUpdateDto,
  NeedsActionDto,
  NeedsHistoryEntryDto,
  NeedsResourceDetailsDto,
} from '@act/shared/data-transfer-objects';
import { needsSelectors } from 'redux/slices/needs.slice';
import ActionHistoryEntry from './ActionHistoryEntry';
import { CallHistoryEntry } from './CallHistoryEntry';
import ResourceDetailsHistoryEntry from './ResourceDetailsHistoryEntry';
import UpdateHistoryEntry from './UpdateHistoryEntry';
import { VisitHistoryEntry } from './VisitHistoryEntry';

interface HistoryEntryProps {
  need: NeedDto;
  historyEntry: NeedsHistoryEntryDto;
  detailMode?: boolean;
  editMode?: boolean;
}

const HistoryEntry = ({
  need,
  historyEntry,
  detailMode,
  editMode,
}: HistoryEntryProps) => {
  const action: NeedsActionDto = needsSelectors.useSelectActionById(
    historyEntry.actionId
  );
  const needUpdate: NeedUpdateDto = needsSelectors.useSelectNeedUpdateById(
    historyEntry.needUpdateId
  );
  const resourceDetails: NeedsResourceDetailsDto =
    needsSelectors.useSelectResourceDetailsById(historyEntry.resourceDetailsId);

  if (historyEntry.actionId) {
    return (
      <ActionHistoryEntry
        need={need}
        action={action}
        detailMode={detailMode}
        editMode={editMode}
      />
    );
  } else if (historyEntry.needUpdateId) {
    return (
      <UpdateHistoryEntry
        need={need}
        needUpdate={needUpdate}
        detailMode={detailMode}
      />
    );
  } else if (historyEntry.resourceDetailsId) {
    return <ResourceDetailsHistoryEntry resourceDetails={resourceDetails} />;
  } else if (historyEntry.callId) {
    return <CallHistoryEntry historyEntry={historyEntry} />;
  } else if (historyEntry.visitId) {
    return <VisitHistoryEntry historyEntry={historyEntry} />;
  }
  return (
    <div>
      Entry with actionId: {historyEntry.actionId} and needUpdateId:{' '}
      {historyEntry.needUpdateId} and resourceDetailsId:{' '}
      {historyEntry.resourceDetailsId}
    </div>
  );
};

export default HistoryEntry;
